import { Icons } from '@/components/Icon'
import RankInfoBlock from '../RankInfoBlock'
import { determineRank } from '../../utils'

type RankWithPrevious = {
  previous: number
  current: number
}

type ConvertSuccessState = 'default' | 'breached' | 'below'

const getConvertSuccessState = (
  rank: RankWithPrevious
): ConvertSuccessState => {
  const isCurrentRankEligible = determineRank(rank.current) === 'Eligible'
  const isPreviousRankEligible = determineRank(rank.previous) === 'Eligible'

  let state: ConvertSuccessState = 'default'

  if (!isPreviousRankEligible && isCurrentRankEligible) {
    state = 'breached'
  } else if (!isCurrentRankEligible) {
    state = 'below'
  }

  return state
}

const getSuccessContent = (
  state: ConvertSuccessState
): {
  title: string
  description: string
} => {
  switch (state) {
    case 'breached':
      return {
        title: 'You’re in the top 333!',
        description:
          'You made it! Keep an eye on the leaderboard to make sure your score stays at or above Rank 333!'
      }
    case 'below':
      return {
        title: 'Keep Climbing!',
        description:
          "You're not in the top 333 yet. Convert more to earn your place!"
      }
    default:
      return {
        title: 'Points Increased',
        description:
          'You are in the top 333 — for now! Keep an eye on the leaderboard!'
      }
  }
}

export const CONVERT_SUCCESS_MODAL_CONTENT = (
  rank: RankWithPrevious,
  onPrimaryClick: () => void,
  onSecondaryClick: () => void
) => {
  const state = getConvertSuccessState(rank)
  const { title, description } = getSuccessContent(state)
  const icon: Icons = state === 'below' ? 'trophyIneligible' : 'trophy'

  return {
    title,
    headerGraphic: {
      icon,
      theme: 'arcade'
    },
    description,
    secondaryButton: {
      theme: 'secondary',
      label: 'Inventory',
      onClick: onSecondaryClick
    },
    primaryButton: {
      theme: 'green-arcade',
      label: 'Leaderboard',
      onClick: onPrimaryClick
    },
    children: <RankInfoBlock rank={rank.current} />
  }
}
